var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTikTok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -278,
    y: -72,
    display: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25,6h-1c-1.103,0-2-0.897-2-2V3c0-0.552-0.447-1-1-1h-4c-0.553,0-1,0.448-1,1v17.5c0,1.378-1.121,2.5-2.5,2.5S11,21.878,11,20.5s1.121-2.5,2.5-2.5c0.089,0,0.168-0.029,0.25-0.05C13.832,17.971,13.911,18,14,18c0.553,0,1-0.448,1-1v-4c0-0.552-0.447-1-1-1c-0.089,0-0.168,0.029-0.25,0.05C13.668,12.029,13.589,12,13.5,12C8.813,12,5,15.813,5,20.5S8.813,29,13.5,29c4.461,0,8.124-3.457,8.466-7.832C21.976,21.111,22,21.059,22,21v-9.338c1.554,0.529,3.049,0.34,3.132,0.329C25.629,11.925,26,11.501,26,11V7C26,6.448,25.553,6,25,6z M24,10.023c-0.688-0.039-1.647-0.21-2.368-0.798c-0.299-0.244-0.711-0.293-1.061-0.128C20.223,9.262,20,9.614,20,10v10.5c0,3.584-2.916,6.5-6.5,6.5S7,24.084,7,20.5c0-3.415,2.649-6.218,6-6.475v2.025c-2.244,0.252-4,2.139-4,4.449c0,2.481,2.019,4.5,4.5,4.5s4.5-2.019,4.5-4.5V4h2c0,2.206,1.794,4,4,4V10.023z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/tik-tok.8d2faed803f4accfdc775ba207c2cf9b.svg";
export { ForwardRef as ReactComponent };